export const paymentNumberTypeOptions = ['check', 'remittance']
